import React from 'react'
import GoogleLogin from 'react-google-login'
import AccountSubsection from './AccountSubsection'
import AccountButton from './AccountButton'
import AccountServiceStatus from './AccountServiceStatus'
import TopPageHeader from '../pageHeaders/TopPageHeader'
import {getUserDisplayName} from '../../utils/userDisplayName'
import ProfilePic from '../ProfilePic'
import Icon from '../misc/Icons'
import { NavLink,withRouter } from 'react-router-dom' 
import AppleLogin from 'react-apple-login'
  
const responseGoogle = (response) => {}
  
class AccountPage extends React.Component{
	
	constructor(){
		super()
		this.onChange=this.onChange.bind(this)
		this.appleCallback=this.appleCallback.bind(this)
		this.confirmAddGoogleWithPassword=this.confirmAddGoogleWithPassword.bind(this)		
		this.state={
			passwordfield:'',  
			passwordConfirmfield:''
		}
	}
	
	confirmAddGoogleWithPassword(googleUser){
		this.props.showGoogleAccountAuthenticationModal(googleUser)
	}

	showUpgrade(){
		window.location.hash='upgrade'
	}

	onChange(e){
		this.setState({passwordfield:e.target.value})
	}

	appleCallback(data){
		if(data.authorization){
			this.props.showAppleAccountAuthenticationModal(data)
		}
	}

	render(){
		const {user,service,billingInfo,signinMethods,uploadingImage,hasClaimedSummerCoupon}=this.props
		const displayedName = getUserDisplayName(user)

	
		let userHasGoogleOnly = false
		let userHasAppleOnly = false
		let userHasEmailPasswordOnly = false
		let userHasGoogleAndPassword = false
		let userHasAppleAndPassword = false


		if(signinMethods){
			if(signinMethods.password){
				if(signinMethods.google){
					userHasGoogleAndPassword=true
				}else if(signinMethods.apple){
					userHasAppleAndPassword = true
				}else userHasEmailPasswordOnly=true
			}else if(signinMethods.google){
				userHasGoogleOnly=true
			}else if(signinMethods.apple){
				userHasAppleOnly = true
			}
		}

		let accountServiceStatus
		if(service.pass || service.providedBy){
			accountServiceStatus='pass'
		}else if(service.product ==='free'){
			accountServiceStatus='free'
		}else if(service.product ==='plus'){
			accountServiceStatus=service.status
		}

		const payPalEmail = user.payoutDestination

		return(
			<React.Fragment>

				<TopPageHeader	
					key='topHeader'
					location='account' 						 
					height={130}
					header={
						<React.Fragment>
							<div className='pageHeaderTop--account-headerRow-profilePicContainer'>
							
								{!user.image && !uploadingImage &&
									<React.Fragment>
										<input 
											id='file'
											type='file'
											onChange={this.props.handleFileUpload}
											value={''}
											style={{position:'absolute', opacity: '0', height:'0', width: '0'}}
											name='uploadProfilePic'	
											accept=".png,.jpg,.jpeg,.tif,.tiff"
										/>							     
										<label htmlFor='file'>
											<div className='pageHeaderTop--account-headerRow-button pageHeaderTop--account-headerRow-button--uploadPic'>
												<Icon name='plus' />
											</div>
										</label>
									</React.Fragment>
								}

								
								{user.image && !uploadingImage &&
									<div className='pageHeaderTop--account-headerRow-button pageHeaderTop--account-headerRow-button--removePic' onClick={this.props.handleRemoveProfileImage}>
										<Icon name='circle-with-close' />
									</div>
								}

								{uploadingImage &&
									<div className='pageHeaderTop--account-headerRow-profilePicUploading'>
										<div className='pageHeaderTop--account-headerRow-profilePicUploading-loadingSpinnerContainer'>
											<div className='pageHeaderTop--account-headerRow-profilePicUploading-loadingSpinner' />
										</div>
									</div>
								}
								
								{!uploadingImage &&
									<ProfilePic size='56' borderRadius='6' user={user} />
								}

								
							</div>							
							{user.firstName || ''} {user.lastName || ''}
						</React.Fragment>
					}						
				/>				

				<AccountSubsection label='Display Name' >
					{displayedName}
					<div className='account-subsection-actionRow'>
						<AccountButton label='Update Name' onClickFunction={this.props.showUpdateNameModal}/>
					</div>
				</AccountSubsection>

			

				{user.username && 					
					<AccountSubsection label='Creator Account' >
							Username <span className='account-subsection-light'>{user.username}</span>
	
							<NavLink
							to={`/${user.username}`}
							className='account-subsection-creatorURL'
							>
								{`${window.location.host}/${user.username}`}
							</NavLink>							
													
							<AccountButton label='Edit Username' subtle onClickFunction={this.props.showUpdateUsernameModal}/>
								
							{!payPalEmail &&								
								<AccountButton label='Add PayPal Email for Creator Fund Payouts'  onClickFunction={this.props.showPaypalEmailModal} />																
							}	
							{payPalEmail &&				
								<React.Fragment>
									<div className='account-subsection-actionRow'>				
										PayPal Account Email&nbsp;<span className='account-subsection-light'>{payPalEmail}</span> 
									</div>
									<AccountButton label='Edit PayPal Account Email' subtle onClickFunction={this.props.showPaypalEmailModal} />
								</React.Fragment>
							}	


							
						</AccountSubsection>
				
				}

				<AccountServiceStatus 
					accountServiceStatus={accountServiceStatus}
					service={service}
					showDowngradePlanModal={this.props.showDowngradePlanModal}
					billingInfo={billingInfo}
					upcomingInvoice={this.props.upcomingInvoice}
					showUpdatePaymentInfoModal={this.props.showUpdatePaymentInfoModal}
					showBillingInfoModal={this.props.showBillingInfoModal}	
					hasClaimedSummerCoupon={hasClaimedSummerCoupon}			
					showSwitchPlanModal={this.props.showSwitchPlanModal}
					showAddLicenseKeyModal={this.props.showAddLicenseKeyModal}
				/>


					{userHasEmailPasswordOnly &&
						<AccountSubsection 
							label='Sign in and Authentication' 
							name='authentication--emailPasswordOnly'
						>

							Email Address <span className='account-subsection-light'>{user.email}</span>
							
							<div className='account-subsection-actionRow'>
								<AccountButton label='Update Email Address' onClickFunction={this.props.showUpdateEmailModal}/>
								<AccountButton label='Edit Password' onClickFunction={this.props.showChangePasswordModal}/>
								{user &&
									<GoogleLogin
				 							clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
				  						onSuccess={(googleUser)=>{this.confirmAddGoogleWithPassword(googleUser)}}
				  						onFailure={responseGoogle}
				  						className='btn btn--mid account-accountBtn'
				  						loginHint={user.email}
				 						>
				 						Add Google Sign-in
									</GoogleLogin>
							}

							{user &&
									<AppleLogin 
										clientId={process.env.REACT_APP_SIGN_IN_WITH_APPLE_CLIENT_ID} 
										redirectURI={process.env.REACT_APP_SIGN_IN_WITH_APPLE_REDIRECT_URI}
										usePopup={true} 
										callback={this.appleCallback}
										scope={"email name"}
										responseType={"query"}
										render={(props)=>{return(<button className='btn btn--mid account-accountBtn'onClick={props.onClick}> Add Apple Sign-in</button>)}}
									/>	
							}

							


							</div>
						</AccountSubsection>
					}

					{userHasGoogleOnly &&
						<AccountSubsection 
							label='Sign in and Authentication' 
							name='authentication--googleOnly'
						>

							Google Sign-in <span className='account-subsection-light'>{user.email}</span>

							<div className='account-subsection-actionRow'>
						
								<GoogleLogin
		 							clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
		  							onSuccess={(googleUser)=>{this.props.showConfirmUpdateGoogleModal(googleUser)}}
		  							onFailure={responseGoogle}
		  							className="btn btn--mid account-accountBtn account-accountBtn--updateGoogle"
		 						>
		 							Change Google Account

			 						<div className='account-accountBtn-sub'>
			 							Select New Account
			 						</div>
			 											
								</GoogleLogin>

								<AccountButton label='Add Email and Password' onClickFunction={this.props.showAddPasswordModal}/>
							</div>
							
						</AccountSubsection>
					}

					{userHasAppleOnly &&
						<AccountSubsection 
							label='Sign in and Authentication' 
							name='authentication--googleOnly'
						>

							Apple Sign-in <span className='account-subsection-light'>{user.email}</span>

							<div className='account-subsection-actionRow'>
					
								<AccountButton label='Add Email and Password' onClickFunction={this.props.showAddPasswordModal}/>
							</div>
							
						</AccountSubsection>
					}





					{userHasGoogleAndPassword &&
						<AccountSubsection 
							label='Sign in and Authentication' 
							name='authentication--googleAndEmailPassword'
						>
							Email Address <span className='account-subsection-light'>{user.email}</span>
							<AccountButton name='editPassword' label='Edit Password' onClickFunction={this.props.showChangePasswordModal}/>

							Google Sign-in <span className='account-subsection-light'>{user.email}</span>
							<AccountButton name='removeGoogle' label='Remove Google Sign-in' onClickFunction={()=>{this.props.showGoogleAccountAuthenticationModal(null)}}/>

						</AccountSubsection>
					}

					{userHasAppleAndPassword &&
						<AccountSubsection 
							label='Sign in and Authentication' 
							name='authentication--googleAndEmailPassword'
						>
							Email Address <span className='account-subsection-light'>{user.email}</span>
							<AccountButton name='editPassword' label='Edit Password' onClickFunction={this.props.showChangePasswordModal}/>

							Apple Sign-in <span className='account-subsection-light'>{user.email}</span>
							<AccountButton name='removeGoogle' label='Remove Apple Sign-in' onClickFunction={()=>{this.props.showAppleAccountAuthenticationModal(null)}}/>

						</AccountSubsection>
					}

					
					<AccountSubsection 
						label='Help Links' 
						name='quickLinks'
					>					
						<div className='account-subsection--quickLinks-colContainer'>
							<div className='account-subsection--quickLinks-col'>
								<AccountButton label='Plickers Help Home' onClickFunction={()=>{window.open('https://help.plickers.com','_blank')}} />
								<AccountButton label='Getting Started Guide' onClickFunction={()=>{window.open('https://help.plickers.com/hc/en-us/categories/1260801472210-Getting-Started','_blank')}} />								
								<AccountButton label='Contact Support' onClickFunction={()=>{window.open('https://help.plickers.com/hc/en-us/requests/new','_blank')}} />
							</div>
							<div className='account-subsection--quickLinks-col'>								
								<AccountButton label='Get Plickers Cards' onClickFunction={()=>{window.open('https://help.plickers.com/hc/en-us/articles/360008948034-Get-Plickers-Cards','_blank')}} />							
								<AccountButton label='Get iOS App' onClickFunction={()=>{window.open('https://itunes.apple.com/us/app/plickers/id701184049?mt=8','_blank')}} />
								<AccountButton label='Get Android App' onClickFunction={()=>{window.open('https://play.google.com/store/apps/details?id=com.plickers.client.android','_blank')}} />
							</div>
							<div className='account-subsection--quickLinks-col'>							
								<AccountButton label='Privacy Policy' onClickFunction={()=>{window.open('https://help.plickers.com/hc/en-us/articles/360009090833-Plickers-Privacy-Policy','_blank')}} />
								<AccountButton label='Terms of Service' onClickFunction={()=>{window.open('https://help.plickers.com/hc/en-us/articles/360009090913-Terms-of-Service','_blank')}} />
							</div>
						</div>
					</AccountSubsection>
				
					<AccountButton name='signOut' label='Sign out of Plickers' onClickFunction={this.props.logout} />

			</React.Fragment>	
		)
	}
}

export default withRouter(AccountPage)